module.exports = __webpack_public_path__ + "img/collection_log.27885a0e.svg";